import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, ButtonGroup, Heading, Paragraph, TextButton } from '@zillow/constellation-10';

import type { Lease } from '../../../../models';
import { CANCEL } from '../../../../constants/stringConstants';
import LeaseModal from '../../../../components/Containers/LeaseModal';

type Props = {
  lease: Lease;
  onClose: () => void;
  isOpen: boolean;
};

function DeclineSigningModal({ lease, onClose, isOpen }: Props) {
  const history = useHistory();
  const onDeclineSigning = useCallback(() => history.push(lease.getSummaryPath()), [lease, history]);

  return (
    <LeaseModal
      header={<Heading level={1}>Stop signing your lease?</Heading>}
      isOpen={isOpen}
      onClose={onClose}
      body={
        <Paragraph>
          Your signatures will be removed and, you’ll need to start over when you’re ready to sign again.
        </Paragraph>
      }
      footer={
        <ButtonGroup aria-label="remove signature">
          <TextButton tone="brand" onClick={onClose}>
            {CANCEL}
          </TextButton>
          <Button tone="brand" emphasis="filled" onClick={onDeclineSigning}>
            Stop and remove my signatures
          </Button>
        </ButtonGroup>
      }
    />
  );
}

export default DeclineSigningModal;
